import api from 'api/api'
import { toast } from 'react-toastify'

export const GET_MENUS = '[MENU CONTROL] GET MENUS'
export const SAVE_MENU = '[MENU CONTROL] SAVE MENU'
export const DELETE_MENU = '[MENU CONTROL] DELETE MENU'

export function getMenusAction() {
  const request = api.get(`/menus`)
  return (dispatch) => {
    dispatch({ type: GET_MENUS, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_MENUS, payload: { data: response.data.data } })
    }).catch(error => {
      toast.error('Error al obtener los menus')
      console.log(error)
    }).finally(() => {
      dispatch({ type: GET_MENUS, payload: { loading: false } })
    })
  }
}

export function saveMenuAction(data) {
  const request = api.post(`/menus/save`, data)
  return (dispatch) => {
    dispatch({ type: SAVE_MENU, payload: { saving: true } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: SAVE_MENU, payload: { saved: true, data: response.data.data } })
    }).catch((error) => {
      console.log(SAVE_MENU, error)
    }).finally(() => {
      dispatch({ type: SAVE_MENU, payload: { saving: false } })
    })
  }
}

export function deleteMenuAction(menuId) {
  const request = api.delete(`/menus/${menuId}/delete`)
  return (dispatch) => {
    dispatch({ type: DELETE_MENU, payload: { deleting: true } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: DELETE_MENU, payload: { deleted: true, deleted_id: menuId } })
    }).catch((error) => {
      console.log(DELETE_MENU, error)
    }).finally(() => {
      dispatch({ type: DELETE_MENU, payload: { deleting: false } })
    })
  }
}